import {
  isGithubActionsAvailable,
  EntityRecentGithubActionsRunsCard,
} from '@backstage-community/plugin-github-actions';
import { EntityApiDefinitionCard } from '@backstage/plugin-api-docs';
import {
  EntityLayout,
  EntityAboutCard,
  EntityLinksCard,
  EntitySwitch,
} from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { Grid } from '@material-ui/core';
import { CICDContent } from '../../components/entity-content';
import entityWarningContent from '../../components/entity-content/entity-warning-content';
import { ConfigEditorLink } from '../../components/entity-content/config-editor-link';

export const APIPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        {entityWarningContent}
        <Grid item md={6} xs={12}>
          <EntityAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityLinksCard />
        </Grid>
        <Grid item md={12} xs={12}>
          <EntityCatalogGraphCard height={400} />
        </Grid>
        {/* Lambda list (full width) replaces the providing/consuming-components cards:
            an API's config has many lambdas, which need the room. */}
        <Grid item md={12} xs={12}>
          <ConfigEditorLink />
        </Grid>
        <EntitySwitch>
          <EntitySwitch.Case if={isGithubActionsAvailable}>
            <Grid item md={12} xs={12}>
              <EntityRecentGithubActionsRunsCard limit={5} />
            </Grid>
          </EntitySwitch.Case>
        </EntitySwitch>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/ci-cd" title="CI/CD">
      {CICDContent}
    </EntityLayout.Route>

    <EntityLayout.Route path="/definition" title="Definition">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <EntityApiDefinitionCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
